import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import { useAuthQuery } from '@/hooks/useAuthQuery';

export function App() {
  // Own the `['auth','me']` query lifecycle app-wide: it fetches when a session
  // exists and self-refreshes on staleTime/focus, keeping the user fresh
  // (fixes the stale-user bug). Disabled with no token, so login pages don't
  // fetch. Consumers read it via useCurrentUser (or the auth-store shim).
  useAuthQuery();
  return <RouterProvider router={router} />;
}
